import type { FaireOrderEntity } from "../../entity_types/order";

export const ZAT665J7K6: FaireOrderEntity = {
  token: "ZAT665J7K6",
  type: "order",
  orderNumber: "#ZAT665J7K6",
  status: "fulfilled",
  totalDollars: 121.5,
  customerName: "Sparrow & Thread",
  firstOrder: false,
  placedAt: "Nov 28, 2025",
  shipBy: "Sep 3, 2025",
  sourceLabel: "Faire Direct",
  payoutDate: "Pending Ship",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
